/**
 * @file    房间二 房间三 古琴制作流程
 * @create macaiqi 2025/04/30
 * @update
 */
import { useEffect, useState } from "react";
import { queryArchivesList } from "../../service";
import { htmltoStr } from "../../utils";
import cls from 'classnames'

export default function ImgShade({ floorAt, setShow }) {
    const [data, setData] = useState()

    useEffect(() => {

        queryArchivesList({
            resource: floorAt === 1 ? 'LC1' : 'LC2',
            pagination: {
                size: 0,
                page: 0
            }
        }).then(res => {
            setData(res?.records)
        })


    }, [floorAt])
    return (
        <div className="shade animate__animated animate__fadeIn animate__fast">
            <i
                className="close1"
                onClick={() => {
                    setShow('zqf');
                }}></i>
            <div className={cls("imgcontent ", { "imgcontent2": floorAt === 1, "imgcontent3": floorAt === 2, })}>
                <div className="title">
                    {"古琴制作流程".split("").map((item, index) => {
                        return (
                            <div key={index} className="txt">
                                <span>{item}</span>
                            </div>
                        )
                    })}
                </div>

                <div className="txtlist">
                    {data?.map((item, index) => {
                        return (
                            <div className="item">
                                <div className="t">
                                    {htmltoStr(item.content)}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

        </div>
    );
}
